import { useState } from "react";
import { SetState } from "../types";

export const useControlledValue = <T>(
  externalValue: T | undefined,
  defaultValue: T,
): [T, SetState<T>] => {
  const [value, setValue] = useState(defaultValue);

  return [externalValue ?? value, setValue];
};
